(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9234],{

/***/ 97422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrainingLecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/TrainingLecturer/TrainingLecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Wrapper",
  componentId: "sc-1258wxd-0"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingLecturerelements__Title",
  componentId: "sc-1258wxd-1"
})(["display:block;font-weight:", ";font-size:", ";background:", ";padding:", " 0 ", " 0;border-top-left-radius:", ";border-top-right-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (prop) {
  return prop.withoutBackground ? prop.theme.colors.white : prop.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8));
var SubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TrainingLecturerelements__SubTitle",
  componentId: "sc-1258wxd-2"
})(["font-size:", ";font-weight:", ";padding-bottom:", ";display:block;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h5;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(15));
var Lecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Lecturer",
  componentId: "sc-1258wxd-3"
})(["padding:", " 0;display:flex;flex-direction:column;", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(25), function (prop) {
  return prop.withBackground ? "background: ".concat(prop.theme.colors.darkLight, ";") : '';
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm);
var Information = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Information",
  componentId: "sc-1258wxd-4"
})(["padding-top:", ";@media (min-width:", "px){padding:0 ", ";}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25));
var Position = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingLecturerelements__Position",
  componentId: "sc-1258wxd-5"
})(["font-weight:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
});
var Mail = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TrainingLecturerelements__Mail",
  componentId: "sc-1258wxd-6"
})(["font-weight:", ";display:block;margin-top:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingLecturerelements__Description",
  componentId: "sc-1258wxd-7"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__ImageSection",
  componentId: "sc-1258wxd-8"
})([""]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TrainingLecturerelements__Image",
  componentId: "sc-1258wxd-9"
})(["width:", ";height:auto;"], (0,polished_esm/* rem */.hO)(120));
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingLecturerelements__Name",
  componentId: "sc-1258wxd-10"
})(["font-weight:", ";font-size:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.h5;
});
var Events = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Events",
  componentId: "sc-1258wxd-11"
})(["padding:", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(35), function (prop) {
  return prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey;
});
var Event = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Event",
  componentId: "sc-1258wxd-12"
})(["display:flex;flex-direction:row;flex-wrap:wrap;cursor:pointer;margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(8));
var EventDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__EventDate",
  componentId: "sc-1258wxd-13"
})(["padding-top:", ";padding-right:", ";width:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(250));
var EventName = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__EventName",
  componentId: "sc-1258wxd-14"
})(["color:", ";background:none;padding:", " 0 0 0;cursor:pointer;border:0;text-align:left;margin-bottom:", ";-webkit-box-flex:0;flex:0 0 66.666667%;max-width:66.666667%;@media (max-width:", "px){flex:0 0 100%;max-width:100%;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5), theme/* breakpoints.sm */.A.sm);
var Archives = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Archives",
  componentId: "sc-1258wxd-15"
})(["padding:", " ", ";border-bottom:1px solid ", ";display:flex;flex-direction:column;"], (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(25), function (prop) {
  return prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey;
});
var ArchiveName = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__ArchiveName",
  componentId: "sc-1258wxd-16"
})(["color:", ";background:none;padding:", " 0 0 0;text-align:left;cursor:pointer;border:0;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(5));
var MoreLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__MoreLink",
  componentId: "sc-1258wxd-17"
})(["background:none;border:none;cursor:pointer;padding:0;color:", ";font-size:", ";text-align:left;margin-top:", ";display:flex;flex-direction:row;text-decoration:underline;svg{width:", ";height:", ";transform:rotate(-90deg);}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(10));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TrainingLecturer/TrainingLecturer.tsx












var PARTS;

(function (PARTS) {
  PARTS["TRAININGS"] = "trainings";
  PARTS["CONFERENCES"] = "conferences";
  PARTS["RECORDS"] = "records";
})(PARTS || (PARTS = {}));

var LIMIT_OF_EVENTS_PER_PAGE = 3;

var TrainingLecturerTemplate = function TrainingLecturerTemplate(_ref) {
  var _lecturer$titles, _lecturer$titles2, _lecturer$titles3, _lecturer$titles4;

  var _ref$isDetailPage = _ref.isDetailPage,
      isDetailPage = _ref$isDetailPage === void 0 ? false : _ref$isDetailPage,
      lecturer = _ref.lecturer,
      openedCourseId = _ref.openedCourseId;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      upcomingTrainings = _useState[0],
      setUpcomingTrainings = _useState[1];

  var _useState2 = (0,react.useState)(0),
      upcomingTrainingsCount = _useState2[0],
      setUpcomingTrainingsCount = _useState2[1];

  var _useState3 = (0,react.useState)(3),
      upcomingTrainingsLimit = _useState3[0],
      setUpcomingTrainingsLimit = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      upcomingConferences = _useState4[0],
      setUpcomingConferences = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      upcomingConferencesCount = _useState5[0],
      setUpcomingConferencesCount = _useState5[1];

  var _useState6 = (0,react.useState)(3),
      upcomingConferencesLimit = _useState6[0],
      setUpcomingConferencesLimit = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      records = _useState7[0],
      setRecords = _useState7[1];

  var _useState8 = (0,react.useState)(0),
      recordsCount = _useState8[0],
      setRecordsCount = _useState8[1];

  var _useState9 = (0,react.useState)(3),
      recordsLimit = _useState9[0],
      setRecordsLimit = _useState9[1];

  var handleShowMoreClick = function handleShowMoreClick(part) {
    if (part === PARTS.TRAININGS) {
      lecturer_service/* lecturerApi.upcomingTrainings */.r.upcomingTrainings(lecturer.slug, upcomingTrainingsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref2) {
        var data = _ref2.data;
        setUpcomingTrainings(data === null || data === void 0 ? void 0 : data.results);
        setUpcomingTrainingsCount(data === null || data === void 0 ? void 0 : data.total_count);
        setUpcomingTrainingsLimit(upcomingTrainingsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }

    if (part === PARTS.CONFERENCES) {
      lecturer_service/* lecturerApi.upcomingConferences */.r.upcomingConferences(lecturer.slug, recordsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref3) {
        var data = _ref3.data;
        setUpcomingConferences(data === null || data === void 0 ? void 0 : data.results);
        setUpcomingConferencesCount(data === null || data === void 0 ? void 0 : data.total_count);
        setUpcomingConferencesLimit(recordsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }

    if (part === PARTS.RECORDS) {
      lecturer_service/* lecturerApi.records */.r.records(lecturer.slug, recordsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref4) {
        var data = _ref4.data;
        setRecords(data === null || data === void 0 ? void 0 : data.results);
        setRecordsCount(data === null || data === void 0 ? void 0 : data.total_count);
        setRecordsLimit(recordsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }
  };

  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.upcomingTrainings */.r.upcomingTrainings(lecturer.slug, upcomingTrainingsLimit, 0, openedCourseId ? [openedCourseId] : []).then(function (_ref5) {
      var data = _ref5.data;
      setUpcomingTrainings(data === null || data === void 0 ? void 0 : data.results);
      setUpcomingTrainingsCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
    lecturer_service/* lecturerApi.upcomingConferences */.r.upcomingConferences(lecturer.slug, upcomingConferencesLimit, 0).then(function (_ref6) {
      var data = _ref6.data;
      setUpcomingConferences(data === null || data === void 0 ? void 0 : data.results);
      setUpcomingConferencesCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
    lecturer_service/* lecturerApi.records */.r.records(lecturer.slug, recordsLimit, 0, openedCourseId ? [openedCourseId] : []).then(function (_ref7) {
      var data = _ref7.data;
      setRecords(data === null || data === void 0 ? void 0 : data.results);
      setRecordsCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
  }, []);

  var formatEventDate = function formatEventDate(from, to) {
    var formattedFrom = moment_default()(from);
    var formattedTo = moment_default()(to);
    return formattedTo.diff(formattedFrom, 'days') > 0 ? "".concat(moment_default()(from).format('DD. MM. YYYY'), " - ").concat(moment_default()(to).format('DD. MM. YYYY')) : moment_default()(from).format('DD. MM. YYYY');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      withoutBackground: true,
      children: t('training.lecturer.title')
    }), lecturer && /*#__PURE__*/(0,jsx_runtime.jsxs)(Lecturer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
        children: lecturer !== null && lecturer !== void 0 && lecturer.photo ? /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key)
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg'))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Information, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Name, {
          children: [(_lecturer$titles = lecturer.titles) !== null && _lecturer$titles !== void 0 && _lecturer$titles.before_name ? "".concat((_lecturer$titles2 = lecturer.titles) === null || _lecturer$titles2 === void 0 ? void 0 : _lecturer$titles2.before_name, " ") : '', lecturer.name, " ", lecturer.surname, (_lecturer$titles3 = lecturer.titles) !== null && _lecturer$titles3 !== void 0 && _lecturer$titles3.after_name ? " ".concat((_lecturer$titles4 = lecturer.titles) === null || _lecturer$titles4 === void 0 ? void 0 : _lecturer$titles4.after_name) : '']
        }), lecturer.position && /*#__PURE__*/(0,jsx_runtime.jsx)(Position, {
          children: lecturer.position
        }), lecturer.email && lecturer.email !== 'undefined' && /*#__PURE__*/(0,jsx_runtime.jsx)(Mail, {
          href: "mailto:".concat(lecturer.email),
          children: lecturer.email
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: lecturer.annotation
          }
        })]
      })]
    }), upcomingTrainingsCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Events, {
      withoutBorder: upcomingConferencesCount === 0,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.trainings')
      }), upcomingTrainings === null || upcomingTrainings === void 0 ? void 0 : upcomingTrainings.map(function (event) {
        var _event$eventDate;

        return (_event$eventDate = event.eventDate) === null || _event$eventDate === void 0 ? void 0 : _event$eventDate.map(function (date, key) {
          var _date$venues, _date$venues$, _date$venues2, _date$venues2$;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Event, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(EventDate, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: formatEventDate(date.eventDate.from, date.eventDate.to)
              }), " |", ' ', date.isOnline ? 'Online' : ((_date$venues = date.venues) === null || _date$venues === void 0 ? void 0 : (_date$venues$ = _date$venues[0]) === null || _date$venues$ === void 0 ? void 0 : _date$venues$.city) || ((_date$venues2 = date.venues) === null || _date$venues2 === void 0 ? void 0 : (_date$venues2$ = _date$venues2[0]) === null || _date$venues2$ === void 0 ? void 0 : _date$venues2$.name)]
            }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(EventName, {
              onClick: function onClick() {
                return router.push({
                  pathname: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(event.course.slug)
                });
              },
              children: event.course.title
            })]
          }, key);
        });
      }), (upcomingTrainings === null || upcomingTrainings === void 0 ? void 0 : upcomingTrainings.length) < upcomingTrainingsCount && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.TRAININGS);
        },
        children: t('training.lecturer.showMore')
      })]
    }), upcomingConferencesCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Events, {
      withoutBorder: recordsCount === 0,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.conferences')
      }), upcomingConferences === null || upcomingConferences === void 0 ? void 0 : upcomingConferences.map(function (event) {
        var _event$eventDate2;

        return (_event$eventDate2 = event.eventDate) === null || _event$eventDate2 === void 0 ? void 0 : _event$eventDate2.map(function (date, key) {
          var _date$venues3, _date$venues3$, _date$venues4, _date$venues4$;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Event, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(EventDate, {
              children: [formatEventDate(date.eventDate.from, date.eventDate.to), " |", ' ', ((_date$venues3 = date.venues) === null || _date$venues3 === void 0 ? void 0 : (_date$venues3$ = _date$venues3[0]) === null || _date$venues3$ === void 0 ? void 0 : _date$venues3$.city) || ((_date$venues4 = date.venues) === null || _date$venues4 === void 0 ? void 0 : (_date$venues4$ = _date$venues4[0]) === null || _date$venues4$ === void 0 ? void 0 : _date$venues4$.name)]
            }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(EventName, {
              onClick: function onClick() {
                return router.push({
                  pathname: "".concat(constants/* ROUTES.CONFERENCE */.Z6.CONFERENCE, "/").concat(event.conference.slug)
                });
              },
              children: event.conference.title
            })]
          }, key);
        });
      }), (upcomingConferences === null || upcomingConferences === void 0 ? void 0 : upcomingConferences.length) < upcomingConferencesCount && /*#__PURE__*/(0,jsx_runtime.jsxs)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.CONFERENCES);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
          name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
        }), " ", t('training.lecturer.showMore')]
      })]
    }), recordsCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Archives, {
      withoutBorder: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.records')
      }), records === null || records === void 0 ? void 0 : records.map(function (event, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ArchiveName, {
          onClick: function onClick() {
            return router.push({
              pathname: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(event.course.slug)
            });
          },
          children: event.course.title
        }, key);
      }), (records === null || records === void 0 ? void 0 : records.length) < recordsCount && /*#__PURE__*/(0,jsx_runtime.jsxs)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.RECORDS);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
          name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
        }), " ", t('training.lecturer.showMore')]
      })]
    })]
  });
};

/* harmony default export */ var TrainingLecturer = (TrainingLecturerTemplate);

/***/ }),

/***/ 4749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Lecturer/Lecturer.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-bz36ri-0"
})(["margin-top:", ";@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
// EXTERNAL MODULE: ./src/components/TrainingLecturer/TrainingLecturer.tsx + 1 modules
var TrainingLecturer = __webpack_require__(97422);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Lecturer/Lecturer.tsx





var LecturerTemplate = function LecturerTemplate(_ref) {
  var lecturer = _ref.lecturer;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingLecturer/* default */.Z, {
      lecturer: lecturer,
      isDetailPage: true
    })
  });
};

/* harmony default export */ var Lecturer_Lecturer = (LecturerTemplate);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
;// CONCATENATED MODULE: ./src/pages/lektor/[...slug].tsx
















var Lecturer = function Lecturer(props) {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  if (props !== null && props !== void 0 && props.status && (props === null || props === void 0 ? void 0 : props.status) !== 200) return /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
    type: Alert/* AlertTypes.error */.d.error
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.page.common'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer_Lecturer, {
        lecturer: props === null || props === void 0 ? void 0 : props.lecturer
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

Lecturer.getInitialProps = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(ctx) {
    var _yield$lecturerApi$de, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return lecturer_service/* lecturerApi.detail */.r.detail(ctx.query.slug);

          case 3:
            _yield$lecturerApi$de = _context.sent;
            data = _yield$lecturerApi$de.data;
            return _context.abrupt("return", {
              status: 200,
              lecturer: data
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              status: 500
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var _slug_ = (Lecturer);

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var LIST_CUSTOM_COURSES = 'person/list/carousel/custom-courses';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  listCustomCourses: function listCustomCourses() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST_CUSTOM_COURSES);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 83792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lektor/[...slug]",
      function () {
        return __webpack_require__(4749);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6506,9774,2888,179], function() { return __webpack_exec__(83792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);